import React from "react";
import Styles from "./styles.module.scss";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

import coinIcon from '../../../theme/assets/other/tc_crypto_tc_icon.png';

import {setTopUpModalStatus, setWithdrawModalStatus} from "../../../store/cabinet/action";
import {amountHandler} from "../../../helpers/capsule";

// Внутренний баланс приходит без валюты — тикер берём из макета
const BALANCE_CURRENCY = '$TC';

const CabinetMainBalance = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const dashboard = useSelector(store => store.cabinet.dashboard);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetPC}`}>
                <div className={`${Styles.cardWrap} ${Styles.border3dOuterXl}`}>
                    <div className={`${Styles.balanceRow}`}>
                        <div className={`${Styles.balanceIconWrap}`}>
                            <img src={coinIcon} alt={BALANCE_CURRENCY}/>
                        </div>
                        <div className={`${Styles.balancePos}`}>
                            <div className={`${Styles.balanceName}`}>{t('Ваш баланс')}:</div>
                            <div className={`${Styles.balanceValue}`}>
                                {amountHandler(dashboard?.balance)} {BALANCE_CURRENCY}
                            </div>
                        </div>
                    </div>

                    <div className={`${Styles.btnWrap}`}>
                        <div
                            className={`${Styles.cardBtn}`}
                            onClick={()=>{dispatch(setTopUpModalStatus(true))}}
                        >
                            {t('Пополнить')}
                        </div>
                        <div
                            className={`${Styles.cardBtnGhost}`}
                            onClick={()=>{dispatch(setWithdrawModalStatus(true))}}
                        >
                            {t('Вывести')}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetMainBalance;
